import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalController } from '@ionic/angular';
import { UploadItem } from '../models/upload-item';
import { UploadDocumentRequest } from '../models/upload-document-reqest';
import { StateService } from '../../services/state.service';
import { CameraService } from '../../services/camera.service';
import { ToolService } from '../../services/tool.service';

@Component({
  selector: 'lib-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss'],
  standalone: false,
})
export class UploadComponent implements OnInit {
  private translate = inject(TranslateService);

  files: UploadItem[] = [];
  errors: string[] = [];

  @Input()
  autoUpload: boolean;
  @Input()
  machineId: string;
  @Input()
  isProfilePicture: boolean;
  @Input()
  displayName: string;
  @Input()
  constructionDayReportId: string;
  @Output()
  filesChanged: EventEmitter<UploadDocumentRequest[]> = new EventEmitter<
    UploadDocumentRequest[]
  >();
  uniqueId: string;
  @Output()
  uniqueIdChanged: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    public state: StateService,
    public cameraService: CameraService,
    public tools: ToolService,
    public modalController: ModalController
  ) {}

  ngOnInit() {
    this.uniqueId = (Math.random() + 1).toString(36).substring(7);
    this.uniqueIdChanged.emit(this.uniqueId);
  }

  fileInput(files: FileList) {
    this.displayName = this.displayName;
    this.files = [];
    if (!files) return;

    Array.from(files).forEach((file) => {
      const splittedName = file.name.split('.');
      const fileType =
        '.' + splittedName[splittedName.length - 1].toLowerCase();

      const item: UploadItem = {
        file,
        blob: undefined,
        displayName: file.name.substring(0, file.name.lastIndexOf('.')),
        fileType,
      };

      if (!this.state.supportedFileTypes.includes(fileType)) {
        this.errors.push(
          this.translate.instant('upload.typeNotSupported', {
            type: fileType,
            name: item.file.name,
            supported: this.state.supportedFileTypes.join(', '),
          })
        );
      } else if (file.size / 1000 / 1000 < 100) {
        this.files.push(item);
      } else {
        this.errors.push(
          this.translate.instant('upload.sizeExceeded', {
            name: item.file.name,
            size: Math.floor(file.size / 1000 / 1000),
          })
        );
      }
    });
    this.mapFilesToRequests();
  }

  removeFile(index: number) {
    this.files.splice(index, 1);
    if (this.files.length == 0) {
      this.errors = [];
    }
    this.mapFilesToRequests();
  }

  getFileSize(size: number): string {
    return (size / 1000).toFixed(0);
  }

  mapFilesToRequests() {
    if (this.files.length == 0) {
      this.filesChanged.emit([]);
      return;
    }
    const item = this.files[0];
    if (item.file) {
      this.filesChanged.emit(
        this.files.map((x) => ({
          file: x.file,
          fileName: x.file.name,
          displayName: this.isProfilePicture ? this.displayName : x.displayName,
          sizeInBytes: x.file.size,
          machineId: this.machineId,
          isProfilePicture: this.isProfilePicture,
        }))
      );
    } else if (item.blob) {
      this.filesChanged.emit([
        {
          file: item.blob,
          fileName: new Date().toISOString() + item.fileType,
          displayName: this.isProfilePicture
            ? this.displayName
            : item.displayName,

          sizeInBytes: item.blob.size,
          machineId: this.machineId,
          isProfilePicture: this.isProfilePicture,
        },
      ]);
    }
  }
}
